import React, { Component } from "react";
import { Table, Grid, Row, Col, ButtonToolbar } from 'react-bootstrap';
import { PropTypes } from 'prop-types';

import { PaginationBuilder } from '../../PaginationBuilder';
import { PaginationHelper } from '../../helpers/PaginationHelper';
import { SearchHelper } from '../../helpers/SearchHelper';
import { DrawCommand } from '../commands/DrawCommand';
import { DownloadCommand } from '../commands/DownloadCommand';
import { LoadingSpinner } from '../../LoadingSpinner';
import { HandleMessage } from '../../HandleMessage';
import { HandleDialog } from '../../HandleDialog';
import { TitleRow } from '../../TitleRow';
import { SearchBar } from '../../SearchBar';
import { TableButton } from '../../TableButton';

export class ListSpiderMaps extends Component {
    static contextTypes = {
        selectApp: PropTypes.func
    }

    constructor(props) {
        super(props);

        this.state = {
            table: {
                data: [],
                page: 1,
                elementsPerPage: 50,
                filter: ""
            },
            actions: {
                isLoading: true
            },
            commands: {
                drawCommand: new DrawCommand(),
                downloadCommand: new DownloadCommand()
            },
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ""
            },
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            }
        };
    }

    componentDidMount() {
        this.context.selectApp('spidermap', false);
        this.getSpiderMapList();
    }

    // -----------------------

    getSpiderMapList() {
        const { commands } = this.state;

        commands.drawCommand.list(
            (a) => this.successCallback(a),
            (a) => this.errorCallback(a, true)
        );
    }

    // -----------------------

    successCallback(result) {
        const { table, actions } = this.state;

        const totalPages = PaginationHelper.getTotalPages(result.length, table.elementsPerPage);

        actions.isLoading = false;
        table.data = result;
        if (0 !== totalPages) {
            table.page = table.page > totalPages ? totalPages : table.page;
        }
        else {
            table.page = 1;
        }

        // Update table
        this.setState({
            table: table,
            actions: actions
        });
    }

    downloadSuccessCallback(blob, format) {
        var FileSaver = require('file-saver');
        FileSaver.saveAs(blob, format);
    }

    errorCallback(message, reset = false) {
        const { table, actions } = this.state;

        actions.isLoading = false;
        if (reset) {
            table.page = 1;
            table.data = [];
        }

        this.setState({
            table: table,
            actions: actions,
            message: {
                show: true,
                message: message,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    operationSuccessCallback(messageReceived, updateAction, updateDocuments = true, callback = undefined) {
        const { actions, message } = this.state;

        actions[updateAction] = false;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "success",
                title: "Sucesso",
                icon: "ok"
            }
        });

        if (updateDocuments) {
            this.getSpiderMapList();
        }

        if ("function" === typeof callback) {
            callback();
        }
    }

    operationErrorCallback(messageReceived, updateAction) {
        const { actions, message } = this.state;

        actions[updateAction] = false;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    // -----------------------

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ''
            }
        });
    }

    onChangePage(pageNumber) {
        const { table } = this.state;
        table.page = pageNumber;

        this.setState({
            table: table
        });
    }

    onChangeElementsPerPage(elementsPerPage) {
        const { table } = this.state;
        const totalPages = PaginationHelper.getTotalPages(table.data.length, elementsPerPage);

        table.elementsPerPage = elementsPerPage;
        if (0 !== totalPages) {
            table.page = table.page > totalPages ? totalPages : table.page;
        }
        else {
            table.page = 1;
        }

        this.setState({
            table: table
        });
    }

    onSearch(filter) {
        const { table } = this.state;

        table.filter = filter;

        this.setState({
            table: table
        });
    }

    onDeleteClick(data) {
        this.setState({
            dialog: {
                show: true,
                title: "Aviso",
                message: `Tem a certeza que pretende eliminar os documentos para ${data.name} [${data.code}] gerados a ${data.generationDate}`,
                style: "warning",
                icon: "alert",
                argument: {
                    operation: "delete",
                    fileName: data.fileName
                }
            }
        });
    }

    onExitDialog(isToExecute, argument) {
        const { actions } = this.state;

        if (isToExecute) {
            const { commands } = this.state;

            switch (argument.operation) {
                case "delete":
                    actions.isDeleting = true;
                    commands.drawCommand.delete(
                        argument.fileName,
                        (a) => this.operationSuccessCallback(a, "isDeleting"),
                        (a) => this.operationErrorCallback(a, "isDeleting")
                    );
                    break;                

                default: // DO NOTHING
                    break;
            }
        }

        this.setState({
            actions: actions,
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            }
        });
    }

    startDownload(format) {
        const { commands } = this.state;

        commands.downloadCommand.downloadSpiderMap(
            format,
            (a, b) => this.downloadSuccessCallback(a, b),
            (a) => this.errorCallback(a)
        );
    }

    // -----------------------

    renderDownloadLink(format) {
        if (undefined === format || null === format || "" === format) {
            return null;
        }

        return (
            <TableButton
                icon="icon-download"
                onClick={() => this.startDownload(format)}
                title="Transferir"
            />
        );
    }

    renderTable() {
        const { actions } = this.state;

        if (actions.isLoading) {
            return (
                <LoadingSpinner />
            );
        }

        const { table } = this.state;

        const dataFiltered = SearchHelper.search({
            filter: table.filter,
            data: table.data,
            fields: ["code", "name", "generationDate"]
        });
        const totalPages = PaginationHelper.getTotalPages(dataFiltered.length, table.elementsPerPage);
        const activePage = totalPages < table.page ? totalPages : table.page;
        const partialData = dataFiltered.slice((activePage - 1) * table.elementsPerPage, activePage * table.elementsPerPage);

        return (
            <Grid className="margin-top-15" fluid>
                <Row>
                    <Col sm={12}>
                        <Table responsive striped hover className="margin-top-10">
                            <thead>
                                <tr>
                                    <th>Código</th>
                                    <th>Nome</th>
                                    <th>Data Geração</th>
                                    <th>SVG</th>
                                    <th>PNG</th>
                                    <th>PDF</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {partialData.map((data, idx) => <tr key={`layout-${idx}`}>
                                    <td>{data.code}</td>
                                    <td>{data.name}</td>
                                    <td>{data.generationDate}</td>
                                    <td>{this.renderDownloadLink(data.formatSvg, data.name)}</td>
                                    <td>{this.renderDownloadLink(data.formatPng, data.name)}</td>
                                    <td>{this.renderDownloadLink(data.formatPdf, data.name)}</td>
                                    <td>
                                        <ButtonToolbar className="pull-right btn-toolbar">                                            
                                            <TableButton icon="icon-trash" title="Eliminar" onClick={() => this.onDeleteClick(data)} />
                                        </ButtonToolbar>
                                    </td>
                                </tr>
                                )}
                            </tbody>
                        </Table>

                        <PaginationBuilder
                            currentPage={table.page}
                            elementsPerPage={table.elementsPerPage}
                            dataLength={dataFiltered.length}
                            onChangePage={(a) => this.onChangePage(a)}
                            onChangeElementsPerPage={(a) => this.onChangeElementsPerPage(a)} />
                    </Col>
                </Row>
            </Grid>
        );
    }

    render() {
        const { message, dialog } = this.state;

        return (
            <div>
                <TitleRow title="Spider Maps" showSeparator={true}>
                    <Col className="padding-0" xs={12} sm={12} md={8} mdOffset={4}>
                        <div className="search-bar">
                            <SearchBar onSearch={(a) => this.onSearch(a)} />
                        </div>
                    </Col>
                </TitleRow>

                {this.renderTable()}

                <HandleMessage
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    show={message.show}
                    onHide={() => this.onExitMessage()} />

                <HandleDialog
                    show={dialog.show}
                    title={dialog.title}
                    message={dialog.message}
                    style={dialog.style}
                    icon={dialog.icon}
                    argument={dialog.argument}
                    onExit={(a, b) => this.onExitDialog(a, b)} />
            </div>
        );
    }
}
